import { waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkNotOk } from "../shared/templates";

const app = window.app;

export class Tires extends HTMLElement {
	async connectedCallback() {
		await waitForContent("tires");
		this.innerHTML = app.content.tires;

		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton8", "nextButton8"));
		this.querySelector("#tire-damage-slot").replaceWith(renderQuestionOkNotOk("tire-damage", "Tires are in good condition", 8));

		/* Next/previous come from the flow manager — no direction logic needed.
		Bound here rather than in ionViewDidEnter: that event fires on every entry to the page,
		so the listeners accumulate on the same buttons and each handler runs once per
		accumulated listener. connectedCallback runs once per element. */
		const currentRoute = app.routes.tires;
		const nextPage = app.flowManager.getNext(currentRoute);
		const prevPage = app.flowManager.getPrevious(currentRoute);

		if (prevPage) this.querySelector("#backButton8").addEventListener("click", () => previous(prevPage.route));
		if (nextPage) this.querySelector("#nextButton8").addEventListener("click", () => validatePage(nextPage.route));

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(8, pageElement);
		});
	}
}
